/**
 * Runtime configuration for API URLs.
 * Values are read in this order:
 * 1. window.__APP_CONFIG__ (from public/config.json, loaded before app boot)
 * 2. process.env (build-time .env)
 * 3. Hardcoded fallbacks
 *
 * To change the API URL at deployment without rebuilding, update public/config.json
 * (or replace it when deploying).
 */

const DEFAULT_NOCU_API_URL = "https://uat.nocu.lk/nocu-core";

function getRuntimeValue(key) {
	if (typeof window !== "undefined" && window.__APP_CONFIG__ && window.__APP_CONFIG__[key] != null) {
		return window.__APP_CONFIG__[key];
	}
	return undefined;
}

export function getNocuApiUrl() {
	return getRuntimeValue("REACT_APP_NOCU_API_URL") || process.env.REACT_APP_NOCU_API_URL || DEFAULT_NOCU_API_URL;
}

export function getPageApiBase() {
	const base = getRuntimeValue("REACT_APP_API_BASE") || process.env.REACT_APP_API_BASE || getNocuApiUrl() || "";
	return base + "/page";
}

/**
 * Fetches config.json and sets window.__APP_CONFIG__. Call once before rendering the app.
 * Relative URL so it works when deployed to a subpath (e.g. /app/) — config.json must be deployed alongside the app.
 */
export function loadRuntimeConfig() {
	return fetch("config.json", { cache: "no-store" })
		.then((res) => (res.ok ? res.json() : {}))
		.then((config) => {
			window.__APP_CONFIG__ = config;
			return config;
		})
		.catch(() => {
			window.__APP_CONFIG__ = {};
		});
}
